module.exports = __webpack_public_path__ + "ca0941798dd2ee0e4924a2cd6d0a30c3.jpg";